(function (angular) {
angular.module('mobilezuz')
    .controller('ChooseFromNumberOfAreas', ['$scope', 'mDesign', 'areas', function ($scope, mDesign, areas) {
        $scope.areas = areas;

        $scope.cancel = mDesign.cancel;
        $scope.choose = function (address) {
            mDesign.hide({ address: address });
        };
    }]);
})(angular);